import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {RoutesUrl, TranslationKeys} from 'utils/constants/routeConstants';
import NotFoundInfo from 'components/not-found-info';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Navigate, useNavigate} from 'react-router-dom';
import {authAsyncActions, sendVerificationEmail} from '../../redux/pageAsyncActions';
import './styles.scss';
import Loader from '../../components/loader';

export const EmailNotVerified: React.FunctionComponent = () => {
  const {
    auth0User,
    userProfile,
    emailNotVerified,
    verificationEmail,
    verificationEmailSent
  } = useSelector((state: IStore) => state.auth);

  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useGetTranslations({
    translationKey: TranslationKeys.Error
  });

  useEffect(() => {
    console.log('emailNotVerified', emailNotVerified);
    if (auth0User && userProfile && !emailNotVerified) {
      navigate(RoutesUrl.Home, {replace: true});
    }
  }, [emailNotVerified]);

  useEffect(() => {

  }, [verificationEmailSent]);

  function onSendVerificationEmail() {
    if (verificationEmail) {
      dispatch(authAsyncActions[sendVerificationEmail](verificationEmail));
    }
  }

  if (!emailNotVerified) {
    return <Navigate
      to={{pathname: RoutesUrl.Home}}
    />;
  }

  return <div className={'email-not-verified'}>
    {loading.includes(sendVerificationEmail) && <Loader nested/>}
    <NotFoundInfo
      title={intl.formatMessage({
        id: 'gritx.error.emailNotVerified',
        defaultMessage: 'Please verify your email before logging in.'
      })}/>

    {!verificationEmailSent && <GritxButton
      title={intl.formatMessage({
        id: 'gritx.error.sendVerificationEmail',
        defaultMessage: 'Send verification email'
      })}
      variant={ButtonVariant.Primary}
      onClick={onSendVerificationEmail}/>}

    {verificationEmailSent && <div>The email has been sent</div>}
  </div>;
};
